<template>
  <div>
    <div class="row gutter-md">
      <template v-for="(day, index) in operatingHours.data">
        <div
          :key="index"
          class="col-12"
        >
          <q-card class="full-height">
            <q-card-main>
              <div class="row gutter-xs items-center">
                <div class="col-md col-xs-12">
                  <div class="row gutter-md align-items-center">
                    <div
                      class="col-auto"
                      style="width: 100px"
                    >
                      {{ moment.weekdays()[day.week_day] }}
                    </div>
                    <div class="col">
                      <q-field>
                        <q-datetime
                          v-model="day.from_hour"
                          type="time"
                          float-label="From Hour"
                          format="h:mm A"
                          @input="updateOperatingHours(day.id, 'from_hour', ...arguments)"
                        />
                      </q-field>
                    </div>
                    <div class="col">
                      <q-field>
                        <q-datetime
                          v-model="day.to_hour"
                          type="time"
                          float-label="To Hour"
                          format="h:mm A"
                          @input="updateOperatingHours(day.id, 'to_hour', ...arguments)"
                        />
                      </q-field>
                    </div>
                  </div>
                </div>
              </div>
            </q-card-main>
          </q-card>
        </div>
      </template>
    </div>
    <div class="row">
      <h4>Vacation Days</h4>
    </div>
    <div class="row full-row-exactly">
      <div class="col-12 flex-1">
        <bj-crud-form-modal
          ref="crudModal"
          model="VacationDay"
          endpoint-create="admin/vacation-days"
          :fields="fields"
          :callback="beforeSave"
          :date-fields="['date']"
          not-crud
          @saved="$refs.dataTable.refresh()"
        />
        <bj-data-table
          ref="dataTable"
          :with-add-button="userRoleIs($config.roles.SUPER_ADMIN)"
          :with-cell-delete-button="false"
          :with-cell-edit-button="false"
          :with-actions-column="userRoleIs($config.roles.SUPER_ADMIN)"
          add-button-label="Add Vacation Day"
          :columns="columns"
          model="admin/vacation-days"
          many-name="Vacation Days"
          single-name="Vacation Day"
          :query-params="queryParams"
          @add="$refs.crudModal.open('add', newVacationDayPayload)"
        >
          <template
            slot="cell-active"
            slot-scope="{row}"
          >
            <q-chip
              small
              :color="!row.deleted_at ? 'positive' : 'negative'"
            >
              {{ !row.deleted_at ? 'Active' : 'Inactive' }}
            </q-chip>
          </template>
          <template
            slot="cell-markets"
            slot-scope="{row}"
          >
            <template v-if="row.markets.length">
              {{ row.markets.map(m => m.name).join(', ') }}
            </template>
            <template v-else>
              Global
            </template>
          </template>
          <template
            slot="cell-actions"
            slot-scope="{row}"
          >
            <q-btn
              v-if="!row.deleted_at"
              size="sm"
              rounded
              outline
              color="negative"
              icon="delete"
              label="Remove"
              class="q-ml-sm"
              @click.native="deleteVacationDay(row)"
            />
          </template>
        </bj-data-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryParams: null,
      operatingHours: {
        loading: true,
        error: false,
        data: [],
      },
      columns: [
        {
          name: 'date',
          field: 'date',
          label: 'Date',
          sortable: true,
        },
        {
          name: 'description',
          field: 'description',
          label: 'Description',
          sortable: true,
        },
        {
          name: 'active',
          field: 'active',
          label: 'Status',
          sortable: false,
        },
        {
          name: 'markets',
          field: 'markets',
          label: 'Markets',
          sortable: false,
        },
      ],
      fields: [
        {
          name: 'date',
          type: 'date',
          label: 'Date',
          min: new Date(),
          rules: ['required'],
          class: 'col-xs-12 col-md-6',
          utc: true,
        },
        {
          name: 'description',
          type: 'text',
          rules: ['required'],
          label: 'Description',
          class: 'col-xs-12 col-md-6',
        },
        {
          name: 'markets',
          type: 'chips-autocomplete',
          label: 'Markets (if not provided will be set globally)',
          class: 'col-xs-12',
          placeholder: 'Add a market...',
          search: (query) => this.markets
            .filter((market) => market.name.toLowerCase().includes(query.toLowerCase())),
          toLabel: (market) => `${market.name} #${market.id}`,
        },
      ],
      newVacationDayPayload: {
        date: null,
        description: '',
        markets: [],
      },
      markets: [],

    };
  },
  created() {
    [this.queryParams] = this.applySortingAndFiltering(this.queryParams, null);
    this.init();
    this.fetchMarkets();
  },
  mounted() {
    this.$root.$on('fetched', (queryParams) => {
      if (this.queryParams !== null && (queryParams.page != this.queryParams.page
          || queryParams.limit != this.queryParams.limit)) {
        this.queryParams.page = queryParams.page;
        this.queryParams.limit = queryParams.limit;
      }
    });
  },
  methods: {
    init(refresh) {
      if (refresh) {
        this.operatingHours.loading = true;
        this.operatingHours.error = false;
      }
      this.fetchOperatingHours().then((response) => {
        const operatingHours = response.map((item) => ({
          id: item.id,
          week_day: item.week_day,
          from_hour: this.HHMMSSToDate(item.from_hour),
          to_hour: this.HHMMSSToDate(item.to_hour),
        }));
        this.operatingHours.data = operatingHours;
        this.operatingHours.loading = false;
      }).catch((error) => {
        this.operatingHours.error = error;
      });
    },
    fetchOperatingHours() {
      return this.api().request('GET', 'availability-days/platform');
    },
    fetchMarkets() {
      this.api().request('GET', 'admin/markets', {}, {
        paginate: 0,
      }).then((markets) => this.markets = markets);
    },
    updateOperatingHours(id, field, value) {
      const data = {};
      data[field] = this.dateToHHMMSS(value);

      this.api().request('PUT', `availability-days/${id}`, data).then(() => {
        this.uiNotify('Updated', 'positive', 1);
      }).catch((error) => {
        this.uiNotify(error.message || 'Error occurred', 'negative');
      });
    },
    deleteVacationDay(vacationDay) {
      const formattedDate = this.$momentUtil(vacationDay.date, null).toDateFormat();
      this.uiConfirm(
        `Are you sure you want to delete this Vacation day at ${formattedDate}?`,
      ).then(() => {
        this.api()
          .request('DELETE', `admin/vacation-days/${vacationDay.id}`)
          .then(() => {
            this.uiNotify(`Vacation day at ${formattedDate} was deleted`);
            this.$refs.dataTable.refresh();
          });
      });
    },
    beforeSave(payload) {
      return {
        ...payload,
        markets: payload.markets.map((market) => market.id),
      };
    },
  },
};
</script>
